import { State, Action, StateContext, Selector } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { DealNote } from 'app/models/dto/dealNote.model';
import { AddDealNote, DeleteDealNote, GetDealNotes, UpdateDealNote } from './dealNote.action';
import { DealNoteService } from 'app/services/dealNotes/dealNote.service';
import { differenceInSeconds } from 'date-fns';

export class DealNoteStateModel {
	dealNotes: DealNote[];
}

@State<DealNoteStateModel>({
	name: 'dealNotes',
	defaults: {
		dealNotes: []
	}
})

@Injectable()
export class DealNoteState {

  @Selector()
	static dealNotes(state: DealNoteStateModel) {
    return state.dealNotes;
  }

	constructor(
    private dealNoteService: DealNoteService,
  ) {}

	@Action(GetDealNotes)
	getDealNotes({ patchState }: StateContext<DealNoteStateModel>, { dealId }: GetDealNotes) {
    return this.dealNoteService.getDealNotes(dealId).pipe(tap(dealNotes => {
      const sortedNotes = dealNotes.sort((left: DealNote, right: DealNote) => 
	  		differenceInSeconds(new Date(right.created), new Date(left.created)));
      patchState({ dealNotes: sortedNotes });
    }));
	}

	@Action(AddDealNote)
	addDealNote({ getState, patchState }: StateContext<DealNoteStateModel>, { dealNote }: AddDealNote) {
    return this.dealNoteService.save(dealNote).pipe(tap(newDealNote => {
      newDealNote.lenderUserName = dealNote.lenderUserName;
      newDealNote.created = new Date();
      const dealNotesCopy = [ newDealNote, ...getState().dealNotes];
			patchState({ dealNotes: dealNotesCopy });
		}));
	}

	@Action(DeleteDealNote)
	deleteDealNote({ getState, patchState }: StateContext<DealNoteStateModel>, { dealNoteId }: DeleteDealNote) {
		return this.dealNoteService.delete(dealNoteId).pipe(tap(() => {
			patchState({ dealNotes: getState().dealNotes.filter(dealNote => dealNote.id !== dealNoteId) });
		}));
	}

	@Action(UpdateDealNote)
	updateDealNote({ getState, patchState }: StateContext<DealNoteStateModel>, { dealNoteId, content }: UpdateDealNote) {
    return this.dealNoteService.update(dealNoteId, content).pipe(tap(updated => {
      if (updated) {
        const state = getState();
        const dealNotes = [...state.dealNotes];
        const updatedNoteIndex = dealNotes.findIndex(dealNote => dealNote.id === dealNoteId);
        dealNotes[updatedNoteIndex].content = content;
        patchState({ dealNotes });
      }
		}));
	}
}
